import * as Yup from "yup";
import { createFields } from "../helpers/createFields.js";
import { shouldAllowAllPhoneTypes } from "../helpers/featureFlags.js";
import getAgeFromBirthday from "../helpers/getAgeFromBirthday.js";
import { buildValidationSchema } from "../yup/buildValidationSchema.js";
import { addressValidation, emailValidation, phoneValidation, mobilePhoneValidation } from "../yup/yup.js";
import "../../../ana-toolbox/ana-toolbox.js";
import "../../../../../constants/date/date.js";
import "../../../../../type/Appointment.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "date-fns";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../helpers/predicates.js";
import "../yup/emailValidation.js";
const EMAIL_ERROR = "email_error";
const PHONE_ERROR = "phone_error";
const AGE_VALIDATION = 70;
Yup.addMethod(Yup.string, "address", addressValidation);
Yup.addMethod(Yup.string, "customEmail", emailValidation);
Yup.addMethod(Yup.string, "phoneNumber", phoneValidation);
Yup.addMethod(Yup.string, "mobilePhoneNumber", mobilePhoneValidation);
const getEmailSchema = (form) => {
  const requiredSchema = Yup.string().email(EMAIL_ERROR).customEmail(EMAIL_ERROR).required(EMAIL_ERROR);
  const optionalSchema = Yup.string().email(EMAIL_ERROR).customEmail(EMAIL_ERROR);
  if (!form.birthday)
    return requiredSchema;
  const age = getAgeFromBirthday(form.birthday);
  if (age < AGE_VALIDATION)
    return requiredSchema;
  if (form.phone)
    return optionalSchema;
  return requiredSchema;
};
const getPhoneSchema = (form) => {
  const mobileRequiredSchema = Yup.string().mobilePhoneNumber(PHONE_ERROR).required(PHONE_ERROR);
  const phoneRequiredSchema = Yup.string().phoneNumber(PHONE_ERROR).required(PHONE_ERROR);
  const optionalSchema = Yup.string().phoneNumber(PHONE_ERROR);
  if (!form.birthday)
    return mobileRequiredSchema;
  const age = getAgeFromBirthday(form.birthday);
  if (age < AGE_VALIDATION)
    return mobileRequiredSchema;
  if (!form.email)
    return phoneRequiredSchema;
  return optionalSchema;
};
const getFieldWithRequiredValidationByAge = (dateOfBirth, dependentValue) => {
  if (!dateOfBirth)
    return true;
  const age = getAgeFromBirthday(dateOfBirth);
  if (age < AGE_VALIDATION)
    return true;
  return !dependentValue;
};
const createValidateConditionalSchema = (getSchema) => {
  return function(value) {
    const form = this.parent || {};
    const schema = getSchema(form);
    try {
      schema.validateSync(value);
      return true;
    } catch (e) {
      return this.createError({
        path: this.path,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        message: e.message
      });
    }
  };
};
const fields = createFields({
  street: {
    __type: "address",
    label: "field.street_and_number",
    name: "street",
    isRequired: true,
    inputProps: {
      autoFocus: true
    },
    validation: Yup.string().address("invalid_address_error").required("street_and_number_error")
  },
  zipCode: {
    __type: "text",
    label: "field.zipCode",
    name: "zipCode",
    isRequired: true,
    validation: Yup.string().required("zipCode_error"),
    hooks: {
      beforeChange: (_value, helpers, _event) => {
        helpers.setFieldValue("addressGoogleVerified", false);
      }
    }
  },
  city: {
    __type: "text",
    label: "field.city",
    name: "city",
    isRequired: true,
    validation: Yup.string().required("city_error"),
    hooks: {
      beforeChange: (_value, helpers, _event) => {
        helpers.setFieldValue("addressGoogleVerified", false);
      }
    }
  },
  email: {
    __type: "text",
    label: "field.email",
    name: "email",
    isRequired: (form) => getFieldWithRequiredValidationByAge(form.birthday, form.phone),
    inputProps: {
      type: "email"
    },
    validation: Yup.string().test("conditionalEmail", EMAIL_ERROR, createValidateConditionalSchema(getEmailSchema))
  },
  phone: {
    __type: "phone",
    label: "field.phone",
    name: "phone",
    flagSource: (country) => {
      return `https://country-iso-flags.s3.eu-central-1.amazonaws.com/${(country.toLowerCase() === "gg" ? "gb" : country.toLowerCase()).toLocaleLowerCase()}.svg`;
    },
    isRequired: (form) => getFieldWithRequiredValidationByAge(form.birthday, form.email),
    inputProps: {
      type: "tel"
    },
    validation: Yup.string().test("conditionalPhone", PHONE_ERROR, createValidateConditionalSchema(getPhoneSchema))
  }
});
const validationSchema = buildValidationSchema(fields);
const getValidationSchemaForClinic = (clinic) => {
  if (!clinic || !shouldAllowAllPhoneTypes(clinic))
    return validationSchema;
  return buildValidationSchema({
    ...fields,
    phone: {
      ...fields.phone,
      validation: Yup.string().phoneNumber("phone_error").required("phone_error")
    }
  });
};
export {
  fields as default,
  getValidationSchemaForClinic,
  validationSchema
};
